( function( global, $ ) {
    "use strict";

    var _events = {
        onRefreshBookingArtistsStrategyField: function() {
            var $bookingArtistsStrategyField = $(this),
                $bookingArtistsField = $bookingArtistsStrategyField.find('[data-form-field="booking_artists"]'),
                $allArtistsControl = $bookingArtistsStrategyField.find('[data-form-control="all_artists"]'),
                $allArtistsLabel = $bookingArtistsStrategyField.find('[data-form-label="all_artists"]');

            if ($allArtistsControl.prop('checked')) {
                $bookingArtistsField.addClass('hidden');
                $allArtistsLabel.removeClass('invisible');
            } else {
                $bookingArtistsField.removeClass('hidden');
                $allArtistsLabel.addClass('invisible');
            }
        },

        onChangeAllArtistsControl: function(ev) {
            var $bookingArtistsStrategyField = $(this).closest('[data-form-field="booking_artists_strategy"]');

            $bookingArtistsStrategyField.trigger('refresh');
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $bookingArtistsStrategyField = $container.find('[data-form-field="booking_artists_strategy"]'),
            $allArtistsControl = $bookingArtistsStrategyField.find('[data-form-control="all_artists"]');

        $bookingArtistsStrategyField
            .on('refresh', _events.onRefreshBookingArtistsStrategyField)
            .trigger('refresh');

        $allArtistsControl.on('change', _events.onChangeAllArtistsControl);
    });

}( window.groots, jQuery ));
